export default {"src":"/_next/static/media/select-drop-arrow.f7c03de6.svg","height":5,"width":10,"blurWidth":0,"blurHeight":0};